import React from 'react';
import { Circles } from 'react-loader-spinner';
import ZappingText from '../zapping';

const LoadingCreateCoin = ({ isLoading, setIsLoading }) => {
  return (
    <div className="w-full h-full fixed inset-0 flex items-center justify-center bg-black bg-opacity-20 backdrop-blur-lg z-50">
      <div className="w-[350px] h-[220px] flex flex-col justify-center items-center relative p-6  bg-[#13141D] rounded-lg shadow-lg">
        <button
          onClick={() => setIsLoading(!isLoading)}
          className="absolute top-6 right-6  hover:brightness-125 text-gray-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className="w-[350px] h-[200px] flex flex-col gap-4 justify-center items-center">
          <Circles
            height="80"
            width="80"
            color="#E4775D"
            ariaLabel="circles-loading"
            visible={true}
          />

          <div className="right-6 text-1xl p-2">
            <ZappingText text={'Transaction processing'} dot={5} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingCreateCoin;
